import PropTypes from 'prop-types'

import { useIsMigrationEnabled } from '_hooks/use-is-migration-enabled'
import AccessDenied from '_pages/access-denied/access-denied.component'

/**
 * Route guard for the Migration feature. Renders children only when Migration is enabled for
 * the current user (see useIsMigrationEnabled: the import-utility flag, targeted to Hapana staff
 * in PostHog). Everyone else gets AccessDenied — keeps customers out even via direct deep-link.
 *
 * NOTE: client-side gate only.
 */
const MigrationGuard = ({ children }) => {
  const { isEnabled, isLoading } = useIsMigrationEnabled()

  // Wait for the flag to resolve before deciding — avoids flashing AccessDenied.
  if (isLoading) {
    return null
  }
  if (!isEnabled) {
    return <AccessDenied />
  }

  return children
}

MigrationGuard.propTypes = {
  children: PropTypes.node,
}

export default MigrationGuard
